import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import axios from 'axios';
import { Authenticationservice } from '../../services/authentication.service';

@Component({
  selector: 'app-doccheckfarmer',
  templateUrl: './doccheckfarmer.component.html',
  styleUrls: ['./doccheckfarmer.component.css']
})
export class DoccheckfarmerComponent implements OnInit , OnDestroy {
  user:any;
  constructor(private auth:Authenticationservice) {
    this.user = this.auth.Authention();
   }
  fmcode:any;
  onerow:any;
  onecode:any;
  ngOnInit(): void {
    this.Loadfarmerinzone();
  } 

  fmlist:any;
  Loadfarmerinzone(){
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_farmer_basic_w?supzone="+this.user.zonedata;
    axios.get(url).then(res => {
     this.fmlist = res.data.recordset;
    }).catch(err => {throw err});
  }

  data:any;

  
  sunland:any;
  Loaddata(){
    if (this.onecode.length != 10) {
      alert('กรุณากรอกเลขรหัสโควตาให้ครบ 10 หลัก')
    }
    else {
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_v_cp6566_visitFM_w?fmcode="+this.onecode;
      axios.get(url).then(res => {
       this.data = res.data.recordset;
       this.sunland = (this.data.map((el:any) => { return parseFloat(el.landvalue)})).reduce((a, b) => a + b, 0);
      }).catch(err => {throw err});
  
      axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_farmer_basic_w?fmcode_b1="+this.onecode).then(res => {
        let data = res.data.recordset;
        this.onerow = data[0];
        console.log(this.onerow)
       }).catch(err => {throw err});
  
       setTimeout(() => {
         window.print();
       }, 2500);
    }

  }

  ngOnDestroy(): void {
  this.fmcode = null;
  this.fmlist = null;
  this.onerow = null;
  this.onecode = null;
  this.data = null;
  this.sunland = null;
  }

}


